import React from 'react';
import { theme } from '../../config/theme';

const styles = {
    screen: {
        position: 'fixed',
        inset: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '1.5rem',
        backgroundColor: theme.colors.primary,
        color: theme.colors.textSecondaryOnDark,
        fontFamily: theme.typography.fontFamily,
        fontSize: '0.9rem',
    },
    icon: { width: '88px', height: '88px', borderRadius: '20px' },
    spinner: {
        width: '28px',
        height: '28px',
        border: '3px solid rgba(246, 247, 246, 0.2)',
        borderTopColor: theme.colors.background,
        borderRadius: '50%',
        animation: 'spin 0.9s linear infinite',
    },
};

// Pantalla de carga con la marca: coincide con el fondo de apertura de la app
// instalada (background_color del manifest), así no hay un salto a blanco.
const SplashScreen = ({ message = 'Cargando…' }) => (
    <div style={styles.screen} role="status" aria-live="polite">
        <img src="/icon-192.png" alt="Axon Capital" style={styles.icon} />
        <div style={styles.spinner} aria-hidden="true" />
        <span>{message}</span>
    </div>
);

export default SplashScreen;
